const link = {
  defaultProps: {
    underline: "always",
    color: "inherit",
  },
};

export default link;
